<ng-container>
  @if (business; as b) {
  <span
    class="business-edge"
    data-test="business-edge"
    aria-hidden="true"
    [style.background]="b.edge"
  ></span>
  }
  <c-container
    [fluid]="true"
    class="navbar-section d-flex align-items-center gap-4"
  >
    <!-- Mobile nav trigger -->
    @if (isMobile) {
    <button
      type="button"
      cButton
      color="primary"
      class="btn btn--primary-gradient navbar-mobile-trigger position-relative d-inline-flex align-items-center justify-content-center"
      (click)="mobileNavRequested.emit()"
      aria-label="Open navigation"
    >
      <span class="navbar-btn__icon">
        <c-icon name="cilMenu"></c-icon>
      </span>
      @if (channelUnread > 0) {
      <span class="navbar-unread-count" data-test="mobile-unread-count">{{
        channelUnread > 99 ? "99+" : channelUnread
      }}</span>
      }
    </button>
    }

    <!-- Mobile: the business in a franchise session, else the brand -->
    @if (isMobile && business) {
    <app-business-hopper [mobile]="true"></app-business-hopper>
    } @if (isMobile && !business) {
    <img
      src="assets/img/brand/SAGEL_LOGO.svg"
      alt="Sagel logo"
      class="mobile-header-logo ms-auto"
    />
    }

    <!-- Left Nav: the business in a franchise session (C29); opens the business hopper (C31) -->
    @if (!isMobile) {
    <c-header-nav
      class="d-none d-lg-flex me-auto navbar-items d-flex align-items-center gap-3"
    >
      @if (business) {
      <app-business-hopper></app-business-hopper>
      }
      <!-- Who is signed in, and into which business; a franchise session already names the business in the hopper -->
      @if (accountEmail || (companyName && !business)) {
      <ng-container
        *ngTemplateOutlet="
          identityCard;
          context: { $implicit: business ? 'identity--compact' : '' }
        "
      ></ng-container>
      }
    </c-header-nav>
    }

    <!-- Assistant + Notifications -->
    @if (!isMobile) {
    <c-header-nav
      class="d-none d-lg-flex navbar-items d-flex align-items-center gap-3"
    >
      @if (assistantEnabled) {
      <button
        type="button"
        class="navbar-btn navbar-btn--solid navbar-btn--icon navbar-btn--ai"
        data-test="assistant-toggle"
        [class.is-active]="assistantOpen"
        [attr.aria-expanded]="assistantOpen"
        [attr.aria-label]="'ASSISTANT.OPEN' | translate"
        [title]="'ASSISTANT.OPEN' | translate"
        (click)="assistantOpen = !assistantOpen"
      >
        <span class="navbar-btn__icon">
          <svg cIcon name="cilSpeech" size="lg"></svg>
        </span>
      </button>
      }
      <a
        routerLink="/pages/notifications"
        class="navbar-btn navbar-btn--solid navbar-btn--icon position-relative"
      >
        <span class="navbar-btn__icon">
          <svg cIcon name="cilBell" size="lg"></svg>
        </span>
        @if (globalUser.user.new_notifications > 0) {
        <c-badge color="success" class="position-absolute badge-rounded">
          {{ globalUser.user.new_notifications }}
        </c-badge>
        }
      </a>
    </c-header-nav>
    }

    <!-- Language Selector -->
    @if (!isMobile) {
    <c-header-nav
      class="d-none d-lg-flex navbar-items d-flex align-items-center gap-3"
    >
      <c-dropdown>
        <button
          cButton
          variant="ghost"
          cDropdownToggle
          color="info"
          class="navbar-btn navbar-btn--solid navbar-btn--lang d-inline-flex align-items-center justify-content-between"
        >
          <span class="navbar-btn__flag">
            @if (currentLang === 'en') {
            <svg
              [cIcon]="icons.cifUs"
              [attr.title]="'HEADER.LANGUAGE.ENGLISH' | translate"
            ></svg>
            } @if (currentLang === 'tr') {
            <svg
              [cIcon]="icons.cifTr"
              [attr.title]="'HEADER.LANGUAGE.TURKISH' | translate"
            ></svg>
            } @if (currentLang === 'es') {
            <svg
              [cIcon]="icons.cifEs"
              [attr.title]="'HEADER.LANGUAGE.SPANISH' | translate"
            ></svg>
            } @if (currentLang === 'el') {
            <svg
              [cIcon]="icons.cifGr"
              [attr.title]="'HEADER.LANGUAGE.GREEK' | translate"
            ></svg>
            } @if (currentLang === 'de') {
            <svg
              [cIcon]="icons.cifDe"
              [attr.title]="'HEADER.LANGUAGE.GERMAN' | translate"
            ></svg>
            }
          </span>
          <span class="navbar-btn__copy">
            <span class="navbar-btn__lang-name">{{
              languageLabels[currentLang] || languageLabels["en"] | translate
            }}</span>
            <span class="navbar-btn__lang-code">{{
              currentLang | uppercase
            }}</span>
          </span>
          <c-icon
            name="cilChevronBottom"
            size="sm"
            class="navbar-btn__caret"
          ></c-icon>
        </button>
        <ul cDropdownMenu dark class="navbar-dropdown">
          <li>
            <a (click)="changeLanguage('en')" cDropdownItem>
              <svg [cIcon]="icons.cifUs" class="me-2"></svg>
              {{ "HEADER.LANGUAGE.ENGLISH" | translate }}
            </a>
          </li>
          <li>
            <a (click)="changeLanguage('tr')" cDropdownItem>
              <svg [cIcon]="icons.cifTr" class="me-2"></svg>
              {{ "HEADER.LANGUAGE.TURKISH" | translate }}
            </a>
          </li>
          <li>
            <a (click)="changeLanguage('es')" cDropdownItem>
              <svg [cIcon]="icons.cifEs" class="me-2"></svg>
              {{ "HEADER.LANGUAGE.SPANISH" | translate }}
            </a>
          </li>
          <li>
            <a (click)="changeLanguage('el')" cDropdownItem>
              <svg [cIcon]="icons.cifGr" class="me-2"></svg>
              {{ "HEADER.LANGUAGE.GREEK" | translate }}
            </a>
          </li>
          <li>
            <a (click)="changeLanguage('de')" cDropdownItem>
              <svg [cIcon]="icons.cifDe" class="me-2"></svg>
              {{ "HEADER.LANGUAGE.GERMAN" | translate }}
            </a>
          </li>
        </ul>
      </c-dropdown>
    </c-header-nav>
    }

    <!-- User Menu -->
    @if (!isMobile) {
    <c-header-nav
      class="d-none d-lg-flex navbar-items d-flex align-items-center gap-3"
    >
      <c-dropdown alignment="end" variant="nav-item">
        <button
          cButton
          [caret]="false"
          cDropdownToggle
          class="navbar-btn navbar-btn--solid navbar-btn--icon d-inline-flex align-items-center justify-content-center"
        >
          <span class="navbar-btn__icon">
            <c-icon name="cilMenu"></c-icon>
          </span>
        </button>
        <ul cDropdownMenu dark class="navbar-dropdown">
          <li>
            <h6 cDropdownHeader>{{ "USER_DROPDOWN.ACCOUNT" | translate }}</h6>
          </li>
          <li>
            <a routerLink="/pages/notifications" cDropdownItem>
              <svg cIcon class="me-2" name="cilEnvelopeOpen"></svg>
              {{ "USER_DROPDOWN.MESSAGES" | translate }}
              @if (globalUser.user.new_notifications > 0) {
              <c-badge color="success" class="ms-2">
                {{ globalUser.user.new_notifications }}
              </c-badge>
              }
            </a>
          </li>
          <li>
            <h6 cDropdownHeader>{{ "USER_DROPDOWN.SETTINGS" | translate }}</h6>
          </li>
          @for (item of accountItems; track item) {
          <li>
            @if (item.url) {
            <a [routerLink]="item.url" cDropdownItem>
              <svg cIcon class="me-2" [name]="item.icon"></svg>
              {{ item.label | translate }}
            </a>
            } @else {
            <button
              type="button"
              cDropdownItem
              [attr.data-test]="item.action"
              (click)="runAction(item.action!)"
            >
              <svg cIcon class="me-2" [name]="item.icon"></svg>
              {{ item.label | translate }}
            </button>
            }
          </li>
          }
          <li>
            <hr cDropdownDivider />
          </li>
          <li>
            <a routerLink="/login" (click)="logout()" cDropdownItem>
              <svg cIcon class="me-2" name="cilAccountLogout"></svg>
              {{ "USER_DROPDOWN.LOGOUT" | translate }}
            </a>
          </li>
        </ul>
      </c-dropdown>
    </c-header-nav>
    }
  </c-container>

  @if (assistantEnabled && assistantOpen && !isMobile) {
  <app-assistant-overlay
    (closed)="assistantOpen = false"
  ></app-assistant-overlay>
  }
</ng-container>

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item" class="navbar-item">
    <button
      cButton
      [caret]="false"
      cDropdownToggle
      class="btn--primary-gradient d-inline-flex align-items-center justify-content-center px-3"
      style="height: 44px; border-radius: 10px"
    >
      <c-icon name="cilMenu" size="lg"></c-icon>
    </button>
    <ul cDropdownMenu dark class="navbar-dropdown">
      <li>
        <h6 cDropdownHeader>{{ "USER_DROPDOWN.ACCOUNT" | translate }}</h6>
      </li>
      <li>
        <a routerLink="/pages/notifications" cDropdownItem>
          <svg cIcon class="me-2" name="cilEnvelopeOpen"></svg>
          {{ "USER_DROPDOWN.MESSAGES" | translate }}
          @if (globalUser.user.new_notifications > 0) {
          <c-badge color="success">
            {{ globalUser.user.new_notifications }}
          </c-badge>
          }
        </a>
      </li>
      <li>
        <h6 cDropdownHeader>{{ "USER_DROPDOWN.SETTINGS" | translate }}</h6>
      </li>
      <li>
        <a routerLink="/pages/profile" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg>
          {{ "USER_DROPDOWN.PROFILE" | translate }}
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a routerLink="/login" (click)="logout()" cDropdownItem>
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          {{ "USER_DROPDOWN.LOGOUT" | translate }}
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #identityCard let-variant>
  <div
    class="identity"
    [ngClass]="variant"
    data-test="identity-card"
    [title]="(companyName ? companyName + ' · ' : '') + accountEmail"
  >
    @if (!business) { @if (logoUrl) {
    <img
      class="identity__logo"
      appLogoContrast
      crossorigin="anonymous"
      [src]="logoUrl"
      [alt]="companyName"
      (error)="logoUrl = null"
    />
    } @else {
    <span class="identity__initial" aria-hidden="true">{{
      accountInitial
    }}</span>
    } }
    <span class="identity__copy">
      @if (companyName && !business) {
      <span class="identity__business">{{ companyName }}</span>
      } @if (accountEmail) {
      <span class="identity__user">{{ accountEmail }}</span>
      }
    </span>
  </div>
</ng-template>
